import { darkTheme, duskTheme, lightTheme, royalBlueTheme } from "../../constants/Themes";
import userContext from "../users/UserContext";
import ThemeContext from "./ThemeContext";
import { useContext, useEffect, useState } from "react";
import { isMobile } from "react-device-detect";

const ThemeState = (props) => {

  const { userSettings,authenticated,loadByUsername } = useContext(userContext);

  // if (!localStorage.getItem("theme")) {
  //   localStorage.setItem("theme", "dark-midnight");
  // }

  // const [themeName, setThemeName] = useState((process.env.REACT_APP_HYBRID_MODE == "false" && !isMobile) ?
  //   (localStorage.getItem("theme") != null)
  //     ? localStorage.getItem("theme")
  //     : "light" : "dark-midnight"
  // );

  const [themeName, setThemeName] = useState(process.env.REACT_APP_HYBRID_MODE == "false"?userSettings!=null?userSettings.theme:"dark-midnight":"dark-midnight");
  const [theme, setTheme] = useState(darkTheme);
  const [showLightTheme, setShowLightTheme] = useState(false);
  // const [theme, setTheme] = useState(lightTheme);

  const handleThemeProviderChange = (value) => {
    
    switch(true){
      case value === "dark-midnight":
        setTheme(darkTheme);
        break;
      case value === "blue-theme":
        setTheme(royalBlueTheme);
        break;
      case value === "dark":
        setTheme(duskTheme);
        break;
      case value === "light":
        // console.log("--- ThemeProvider ---",value);
        setTheme(lightTheme);
        // setTheme(darkTheme);
        break;
      default:
        setTheme(darkTheme);
        break;
    }
  }

  useEffect(()=>{
    if(authenticated){
      if(userSettings != null && process.env.REACT_APP_HYBRID_MODE == "false"){
        // if(userSettings?.theme == "light"){
        //   setThemeName("dark-midnight");
        // }else{
          setThemeName(userSettings?.theme);
      //  }
        handleThemeProviderChange(userSettings?.theme);
      }else{
        setThemeName("dark-midnight");
      }
    }
    
  },[userSettings])

  const getIndividualColor = (darkColor, darkMidnightColor, blueThemeColor, lightColor) =>{
    if(themeName == "dark"){
      return darkColor;
   }else if(themeName == "dark-midnight"){
     return darkMidnightColor;
   }else if(themeName == "blue-theme"){
     return blueThemeColor;
   }else if(themeName === "light"){
     return lightColor;
   }
   return "red";
  }

  const getAlterColor = (darkColor,lightColor) => {
    if(themeName != "light"){
      return darkColor;
    }
    if(lightColor == undefined || lightColor == ""){
      return "#000";
    }
    return lightColor;
  }

  const getThemeColorForTab = (active) => {
    //"white":"#bfbfbf"
    switch(true){
      case themeName === "light" && active:
          return getAlterColor("#C4C4C4","#FFFFFF")

      case themeName === "light" && !active:
        return getAlterColor("#C4C4C4","#5A5A5A")

      case themeName !== "light" && !active:
        return getAlterColor("#bfbfbf","#bfbfbf")

      case themeName !== "light" && active:
        return getAlterColor("white","#bfbfbf")

      default:
        return "";
    }
  }

  const getRowBadgeBackgroundOrBorderColor = (name,type) => {
    if(type == "background"){
      switch(true){
        case themeName === "light" && name == "R":
            return getAlterColor("#D8D7FF","#C4C4C4")
  
        case themeName === "light" && name == "P":
          return getAlterColor("#FFBBBB","#C4C4C4")
  
        case themeName === "light" && name == "F":
          return getAlterColor("#FFC75A","#C4C4C4")
  
        case themeName === "light" && name == "C":
          return getAlterColor("#FFBBBB","#C4C4C4 ")
  
        default:
          return "";
      }
    }else if(type == "border"){
      switch(true){
        case themeName === "light" && name == "R":
            return getAlterColor("1px solid #002A95","#C4C4C4")
  
        case themeName === "light" && name == "P":
          return getAlterColor("1px solid #7E0000","#C4C4C4")
  
        case themeName === "light" && name == "F":
          return getAlterColor("1px solid #7D4B00","#C4C4C4")
  
        case themeName === "light" && name == "C":
          return getAlterColor("1px solid #7E0000","#C4C4C4")
  
        default:
          return "";
      }
    }else if(type == "color"){
      switch(true){
        case themeName === "light" && name == "R":
            return getAlterColor("#C4C4C4","#00158A")
  
        case themeName === "light" && name == "P":
          return getAlterColor("#C4C4C4","#00158A")
  
        case themeName === "light" && name == "F":
          return getAlterColor("#C4C4C4","#00158A")
  
        case themeName === "light" && name == "C":
          return getAlterColor("#C4C4C4","#00158A")
  
        default:
          return "";
      }
    }
    
  }
  const getScrollBarStyleForTheme = (currentThemeName,styleName)=>{ 
      if( currentThemeName==="light"){
        return styleName + "-light";
      }else
      {
        return styleName;
      }   
  }
  const getAlterClass=(currentThemeName,cssClassName)=>{
    if(currentThemeName==='light')
    {
      return cssClassName+'-light';
    }
    return cssClassName;
  }

  const getThemeColor = (action) => {
    switch(true){
      case action === "action-details-background":
        return getIndividualColor("#3e3f43","#101e30","#1D2858","#FFF");

      case action === "modal-header-footer":
        return getIndividualColor("#222","#132c45","#20284B","rgb(209 209 209)");

      case action === "modal-body":
        return getIndividualColor("rgb(22, 21, 20)","#121e30","#030B2C","#f1f1f1");
        
      case action === "active-side-tab":
        return getIndividualColor("#3E3E3E","#27364f","#1D2858","#EEE");       

      case action === "alternate-side-tab":
        return getIndividualColor("#141414","#040910","#030B2C","#FFFFFF");

      case action === "second-alternate-side-tab":
        return getIndividualColor("#141414","#040910","#030B2C","#FFFFFF");

      case action === "report-not-active-tab":
        return getIndividualColor("rgb(69 69 69)","#1f3f67","rgb(32, 40, 75)","rgb(157 157 157)");

      case action === "report-active-tab":
        return getIndividualColor("#838383","#225f9f","#225f9f","#848784")

      case action === "report-template-container":
        return getIndividualColor("#201F1E","#101e30","#1D2858","rgb(255 255 255)")

      case action === "popup-hover":
      return getIndividualColor("#4b4b4b","#263345","#263345","rgb(181 198 243)")

      case action === "tooltip":
        return getIndividualColor("#252525","#101e30","#1D2858","")

      case action === "background-theme":
        return getIndividualColor("#141414","#040910","#030B2C","#FFFFFF");

      case action === "primary-color":
        return getAlterColor("#FFF","#000");

      case action === "border":
        return getAlterColor("1px solid #585858","1px solid #7E7E7E");
      
      case action === "tooltip-border":
        return getAlterColor("1px solid #FFFFFF","1px solid #0078d4");

      case action === "hide-tooltip-border":
        return getIndividualColor("#252525","#101e30","#1D2858","#FFFFFF");

      case action === "study-details-icon":
        return getAlterColor("#C4C4C4","#8aaad4")

      case action === "icon-color":
        return getAlterColor("#C4C4C4","#636363")
      
      case action === "force-reinfrence-icon-color":
        return getAlterColor("#fafafa","#636363")

      case action === "navbar-item-background":
        return getIndividualColor("transparent","transparent","transparent","#E4E4E4")

      case action === "active-viewport":
        return getAlterColor("rgb(255,255,255)","#0078D4")

      case action === "alter-primary-color":
        return getAlterColor("#FFFFFF","#FFFFFF");

      case action === "search-filter-bgm-nonactive":
        return getAlterColor("transparent","#F0F0F0");
      
      case action === "search-filter-nonactive":
        return getAlterColor("#F0F0F0","#2A2929");
      
      case action === "border-topbar-active":
        return getAlterColor(
          "rgb(255, 255, 255, 0.7)", // Active state for dark themes
          "rgb(255, 255, 255, 0.7)" // Active state for light theme
        );
      
      case action === "border-topbar-inactive":
        return getAlterColor(
          "rgb(255, 255, 255)", // Inactive state for dark themes
          "rgb(0, 0, 0)" // Inactive state for light theme
        );

      default:
        return "";
    }
  }


  return (
    <ThemeContext.Provider
      value={{
        theme,
        themeName,
        setThemeName,
        setTheme,
        getThemeColor,
        handleThemeProviderChange,
        getAlterColor,
        getThemeColorForTab,
        getRowBadgeBackgroundOrBorderColor,
        showLightTheme, 
        setShowLightTheme,
        getScrollBarStyleForTheme,
        getAlterClass
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeState;
